//The contents of this file have been generated automatically. Do not edit this file.

import { z } from 'zod';
import {
    CasinoStoreCollectionZod,
    CasinoStoreStatusZod,
    CasinoStoreFetchedCategoriesAndGamesBackofficeModelZod,
    CasinoStoreHttpErrorResponseZod,
} from './schemas';

export const ParamsTypeZOD = z.object({
    collection_slug: CasinoStoreCollectionZod,
    status: CasinoStoreStatusZod,
});
export type ParamsType = z.TypeOf<typeof ParamsTypeZOD>;

const checkResponse = <A>(code: number, decoder: z.ZodType<A>, data: unknown): A => {
    const decodeResult = decoder.safeParse(data);
    if (decodeResult.success) {
        return decodeResult.data;
    }
    console.error('error details', {
        errors: decodeResult.error.errors,
        data
    });
    throw Error(`Response decoding error /casino-store/v1/cms-staff/collection/{collection_slug}/categories-and-games/{status} -> get -> ${code}`);
};


export const Response200ZOD = CasinoStoreFetchedCategoriesAndGamesBackofficeModelZod;
export type Response200Type = z.TypeOf<typeof Response200ZOD>;

export const Response400ZOD = CasinoStoreHttpErrorResponseZod;
export type Response400Type = z.TypeOf<typeof Response400ZOD>;

export const Response401ZOD = CasinoStoreHttpErrorResponseZod;
export type Response401Type = z.TypeOf<typeof Response401ZOD>;

export const Response403ZOD = CasinoStoreHttpErrorResponseZod;
export type Response403Type = z.TypeOf<typeof Response403ZOD>;

export const Response404ZOD = CasinoStoreHttpErrorResponseZod;
export type Response404Type = z.TypeOf<typeof Response404ZOD>;

export const Response500ZOD = CasinoStoreHttpErrorResponseZod;
export type Response500Type = z.TypeOf<typeof Response500ZOD>;


const ExtraHeadersZod = z.object({
    authorization: z.string().optional(),
});
type ExtraHeadersType = z.TypeOf<typeof ExtraHeadersZod>;


export type ApiGetCategoriesAndGamesParamsType = ParamsType;


export type ApiGetCategoriesAndGamesResponseType = 
    {
        status: 200;
        body: Response200Type;
    } | 
    {
        status: 400;
        body: Response400Type;
    } | 
    {
        status: 401;
        body: Response401Type;
    } | 
    {
        status: 403;
        body: Response403Type;
    } | 
    {
        status: 404;
        body: Response404Type;
    } | 
    {
        status: 500;
        body: Response500Type;
    };

export type ApiGetCategoriesAndGamesResponse200Type = Response200Type;

const convertHeaders = (params: Record<string, string | null | undefined>): Record<string, string> => {
    const result: Record<string, string> = {};

    for (const [name, value] of Object.entries(params)) {
        if (value !== null && value !== undefined) {
            result[name] = value;
        }
    }

    return result;
};

export const apiGetCategoriesAndGamesRequest = async (
    api_url: string,
    params: ParamsType,
    extraHeaders: ExtraHeadersType
): Promise<ApiGetCategoriesAndGamesResponseType> => {
    const ok = ParamsTypeZOD.safeParse(params);
    if (!ok.success) {
        console.error('Input parameters do not match the definition from openapi');
    }

    
        
    const query = '';
    const url = `${api_url}/casino-store/v1/cms-staff/collection/${params.collection_slug}/categories-and-games/${params.status}${query}`;
    

    const headers = convertHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        ...extraHeaders
    });

    const response = await fetch(url, {
        method: 'GET',
        headers,
        body: JSON.stringify(undefined),
        credentials: 'include'
    });

    const status = response.status;

    let json = null;

    try {
        const text = await response.text();
        if (text !== '') {
            json = JSON.parse(text);
        }
    } catch (_err) {
        throw Error(`Http status ${status} - json was expected`);
    }
    
    if (status === 200) {
        return { status: 200, body: checkResponse(200, Response200ZOD, json) };
    }

    if (status === 400) {
        return { status: 400, body: checkResponse(400, Response400ZOD, json) };
    }

    if (status === 401) {
        return { status: 401, body: checkResponse(401, Response401ZOD, json) };
    }

    if (status === 403) {
        return { status: 403, body: checkResponse(403, Response403ZOD, json) };
    }

    if (status === 404) {
        return { status: 404, body: checkResponse(404, Response404ZOD, json) };
    }

    if (status === 500) {
        return { status: 500, body: checkResponse(500, Response500ZOD, json) };
    }

    throw new Error(`apiGetCategoriesAndGamesRequest - unhandled response ${status}`);
};
